import React from 'react'
import { Navigate, useLocation } from 'react-router-dom';



const routePageMap = {
  "/admin/admin_user/corporate": 1,
  "/admin/admin_user/hr": 8,
  "/admin/export": 3,
  "/admin/admin_user/uploadeemployee": 2,
  "/admin/admin_user/employee": 9,
  "/admin/admin_user/healthtips": 4,
  "/admin/admin_user/labtest": 11,
  "/admin/admin_user/master": 12,
  "/admin/admin_user/family_member": 10,
  "/admin/admin_user/vfs_uk": 6,
  "/admin/admin_user/credit_note": 13,
  "/admin/admin_user/payment_failed": 14,
  "/admin/admin_user/bls": 5,
  "/admin/admin_user/vfs_team_members": 7,
};

function AdminRoute({ children }) {

//     const location = useLocation();

//     const authToken = localStorage.getItem("Admin");
//     const userData = authToken ? JSON.parse(authToken) : null;
  
//     const token = userData?.data?.token;
//     const role = userData?.data?.role;
//     const permissions = userData?.data?.permission || []; // e.g. [14, 7]
  
//     console.log(token,"token admin route");
//     // Not logged in → login page
//     if (!token) {
//       return <Navigate to="/admin/admin_user/admin_team" replace />;
//     }
  
//     // Allowed roles
//     const allowedRoles = ["adaccountant", "adsales", "adsupport", "admanager","Admin"];
//     // if role is not "Admin", redirect to /admin/admin_team/login
// if (role !== "Admin" && allowedRoles.includes(role)) {
//     return <Navigate to="/admin/admin_team/login" replace />;
//   }
  
//   // if role is not in any allowed role
//   if (!allowedRoles.includes(role) && role !== "Admin") {
//     return <Navigate to="/login" replace />;
//   }
//     // if (!allowedRoles.includes(role)) {
//     //   return <Navigate to="/admin/admin_user/admin_team" replace />;
//     // }
  
//     console.log(allowedRoles,"allowedRoles admin route");
    
//     // Check page permission
//     const pageId = routePageMap[location.pathname];
//     if (pageId && !permissions.includes(pageId)) {
//       return <Navigate to="/admin/admin_user/admin_team" replace />;
//     }
  
//     console.log(pageId,"pageId admin route");
//     console.log(permissions,"permissions admin route");
    
//     // ✅ All good → show page
//     return children;

    const authToken = localStorage.getItem("Admin");
    const token = JSON.parse(authToken)?.data?.token;
    const userData = JSON.parse(authToken); 

    const isAuth = token || undefined;
    const userName = userData?.data?.role;
    const role = userName || undefined;
    return isAuth && (role === "Admin" || role === "adaccountant" || role === "adsales" || role === "adsupport" || role === "admanager") ? children : <Navigate to="/login" />;

}

export default AdminRoute